/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your data to build a bar chart instantly. Use an optional header row for series names and a first column for category labels; extra numeric columns become grouped bars.`)
};

const es_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega tus datos para crear un gráfico de barras al instante. Usa una fila de cabecera opcional para los nombres de las series y una primera columna para las etiquetas de categoría; las columnas numéricas adicionales se convierten en barras agrupadas.`)
};

const de_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie Ihre Daten ein, um sofort ein Balkendiagramm zu erstellen. Verwenden Sie eine optionale Kopfzeile für Seriennamen und eine erste Spalte für Kategoriebezeichnungen; zusätzliche numerische Spalten werden zu gruppierten Balken.`)
};

const nl_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak je data om direct een staafdiagram te bouwen. Gebruik een optionele headerrij voor reeksnamen en een eerste kolom voor categorielabels; extra numerieke kolommen worden gegroepeerde staven.`)
};

const fr_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez vos données pour créer instantanément un graphique à barres. Utilisez une ligne d'en-tête optionnelle pour les noms de série et une première colonne pour les étiquettes de catégorie ; les colonnes numériques supplémentaires deviennent des barres groupées.`)
};

const it_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla i tuoi dati per costruire istantaneamente un grafico a barre. Usa una riga di intestazione opzionale per i nomi delle serie e una prima colonna per le etichette delle categorie; le colonne numeriche extra diventano barre raggruppate.`)
};

const pt_br2_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole seus dados para criar um gráfico de barras instantaneamente. Use uma linha de cabeçalho opcional para os nomes das séries e uma primeira coluna para os rótulos de categoria; colunas numéricas extras se tornam barras agrupadas.`)
};

const pt_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole os seus dados para construir um gráfico de barras instantaneamente. Use uma linha de cabeçalho opcional para os nomes das séries e uma primeira coluna para os rótulos das categorias; as colunas numéricas adicionais tornam-se barras agrupadas.`)
};

const ja_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データを貼り付けると即座に棒グラフが作成されます。任意のヘッダー行で系列名を、最初の列でカテゴリラベルを指定できます。数値列を追加するとグループ化された棒になります。`)
};

const zh_bar_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴数据即可立即生成柱状图。可选表头行用于系列名称，第一列用于类别标签；多余的数值列会生成分组柱状图。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_intro", locale)
	if (locale === "en") return en_bar_intro(inputs)
	if (locale === "es") return es_bar_intro(inputs)
	if (locale === "de") return de_bar_intro(inputs)
	if (locale === "nl") return nl_bar_intro(inputs)
	if (locale === "fr") return fr_bar_intro(inputs)
	if (locale === "it") return it_bar_intro(inputs)
	if (locale === "pt-BR") return pt_br2_bar_intro(inputs)
	if (locale === "pt") return pt_bar_intro(inputs)
	if (locale === "ja") return ja_bar_intro(inputs)
	return zh_bar_intro(inputs)
};